export default __webpack_public_path__ + "static/media/Mark-3-HUD-Radar.61ea3924.jpg";